type Props = {
  className?: string;
};
const SamsungTradeIn = ({ className = '' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="black"
    className={className}
  >
    <path d="M22.8428 9.10059L22.875 15.9453L21.125 15.9531L21.1074 12.2363L10.6709 22.7061L9.25488 21.2939L19.6855 10.8291L15.9941 10.8047L16.0059 9.05469L22.8428 9.10059ZM14.7363 2.70605L4.30859 13.166L8.00488 13.1855L7.99609 14.9355L1.14648 14.9004L1.125 8.04395L2.875 8.03809L2.88672 11.7598L13.3193 1.29395L14.7363 2.70605Z" />
  </svg>
);

export default SamsungTradeIn;
